import { render, staticRenderFns } from "./ProductDetail.vue?vue&type=template&id=24a9fa69&scoped=true&"
import script from "./ProductDetail.vue?vue&type=script&lang=js&"
export * from "./ProductDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ProductDetail.vue?vue&type=style&index=1&id=24a9fa69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a9fa69",
  null
  
)

export default component.exports